export const validateField = (name, value) => {
  let error = '';
  switch (name) {
    case 'username':
      if (!value) {
        error = 'Username is required';
      }
      break;
    case 'password':
      if (!value) {
        error = 'Password is required';
      }
      break;
      case 'subCategoryName':
        if (!value) {
          error = 'Sub Category name is required';
        }
        break;
      case 'selectedSection':
        if (!value) {
          error = 'Section is required';
        }
        break;
      case 'selectedCategory':
        if (!value) {
          error = 'Category is required';
        }
        break;
      case 'contentLink':
        if (!value) {
          error = 'Content link is required';
        }
        break;
      case 'title':
        if (!value) {
          error = 'Title is required';
        }
        break;
      case 'language':
        if (!value) {
          error = 'Language is required';
        }
        break;
      case 'pdfFile':
        if (!value) {
          error = 'PDF file is required';
        }
        break;
      case 'link':
        if (!value) {
          error = 'Link is required';
        }
        break;
    default:
      break;
  }
  return error;
}; 